import React from "react";
import { Drawer as DrawerPrimitive } from "vaul";
import { cn } from "../../lib/utils";

export function Drawer({ shouldScaleBackground = true, ...props }) {
  return <DrawerPrimitive.Root shouldScaleBackground={shouldScaleBackground} {...props} />;
}

export const DrawerTrigger = DrawerPrimitive.Trigger;
export const DrawerPortal = DrawerPrimitive.Portal;
export const DrawerClose = DrawerPrimitive.Close;

export const DrawerOverlay = React.forwardRef(function DrawerOverlay({ className = "", ...props }, ref) {
  return (
    <DrawerPrimitive.Overlay
      ref={ref}
      className={cn("fixed inset-0 z-[110] bg-black/65 backdrop-blur-[2px]", className)}
      {...props}
    />
  );
});

export const DrawerContent = React.forwardRef(function DrawerContent(
  { className = "", children, showHandle = true, ...props },
  ref
) {
  return (
    <DrawerPortal>
      <DrawerOverlay />
      <DrawerPrimitive.Content
        ref={ref}
        className={cn(
          "fixed inset-x-0 bottom-0 z-[120] mt-24 flex max-h-[92vh] flex-col rounded-t-[28px] border border-border bg-card text-card-foreground shadow-2xl outline-none",
          className
        )}
        {...props}
      >
        {showHandle ? <div className="mx-auto mt-3 h-1.5 w-14 rounded-full bg-muted-foreground/25" /> : null}
        {children}
      </DrawerPrimitive.Content>
    </DrawerPortal>
  );
});

export function DrawerHeader({ className = "", ...props }) {
  return <div className={cn("shrink-0 px-4 pb-4 pt-3 text-center sm:px-6", className)} {...props} />;
}

export function DrawerTitle({ className = "", ...props }) {
  return <h2 className={cn("font-display text-lg font-semibold text-foreground sm:text-xl", className)} {...props} />;
}

export function DrawerDescription({ className = "", ...props }) {
  return <p className={cn("mt-1 text-sm text-muted-foreground", className)} {...props} />;
}

export function DrawerBody({ className = "", ...props }) {
  return <div className={cn("min-h-0 flex-1 overflow-y-auto px-4 pb-4 sm:px-6", className)} {...props} />;
}

export function DrawerFooter({ className = "", ...props }) {
  return <div className={cn("shrink-0 border-t border-border px-4 py-4 sm:px-6", className)} {...props} />;
}
